import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, PrimaryButton, Tooltip, centsToUnits } from '@systemeio/ui';
import StripeWrapper from 'modules/profile/user-plan/components/price-plan-columns/components/stripe-wrapper';
import UpgradePlanConfirmationModal from 'modules/profile/user-plan/components/price-plan-columns/components/upgrade-plan-confirmation-modal';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UserPlanTypeEnum } from 'modules/profile/user-plan/enums/user-plan-type-enum';
import { UseUserPlanInterface, UserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
import { twMerge } from 'tailwind-merge';
import { calculatePlanParameters } from '../utils/calculate-plan-params';
export interface HeaderBlockProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  active?: boolean;
  isOneClickUpgradeAvailable?: boolean;
  paymentMethod?: UseUserPlanInterface['customer']['paymentMethod'];
  isPlanUpgradeAvailable?: boolean;
  showWithTax: boolean;
}
const HeaderBlock = t0 => {
  const $ = _c(43);
  const {
    pricePlan,
    billingPeriod,
    active: t1,
    isOneClickUpgradeAvailable: t2,
    paymentMethod,
    isPlanUpgradeAvailable,
    showWithTax
  } = t0;
  const active = t1 === undefined ? false : t1;
  const isOneClickUpgradeAvailable = t2 === undefined ? false : t2;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== active || $[1] !== billingPeriod || $[2] !== isOneClickUpgradeAvailable || $[3] !== isPlanUpgradeAvailable || $[4] !== paymentMethod || $[5] !== pricePlan || $[6] !== showWithTax || $[7] !== t || $[8] !== user?.dashboardLocale) {
    const {
      calculatedCost,
      calculatedCostWithTax,
      calculatedLink,
      calculatedPeriod
    } = calculatePlanParameters(pricePlan, billingPeriod);
    const isPriceInvisible = pricePlan.type === UserPlanTypeEnum.promotion && !calculatedCost || !pricePlan.currency;
    let costTitleShort = "";
    let costTitle = "";
    if (pricePlan.currency) {
      costTitleShort = currencyFormat(centsToUnits(showWithTax ? calculatedCostWithTax : calculatedCost), pricePlan.currency || CurrencyEnum.EURO, user?.dashboardLocale, true);
      costTitle = currencyFormat(centsToUnits(showWithTax ? calculatedCostWithTax : calculatedCost), pricePlan.currency || CurrencyEnum.EURO, user?.dashboardLocale);
    }
    t7 = `headCell-${pricePlan.id}`;
    const t9 = active ? "text-brand-primary" : "text-text-primary";
    if ($[15] !== t9) {
      t8 = twMerge("font-inter text-start h-[150px]  font-bold", t9, "mb-6 min-w-[100px]");
      $[15] = t9;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    const t10 = !active && "border-fill-primary rounded-lg border-solid";
    if ($[17] !== t10) {
      t3 = twMerge("flex flex-col gap-2 border border-transparent px-2 py-2 lg:px-4", t10);
      $[17] = t10;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    let t11;
    if ($[19] !== active) {
      t11 = active ? {
        "data-test": "current-plan"
      } : {};
      $[19] = active;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    let t12;
    if ($[21] !== pricePlan.title || $[22] !== t11) {
      t12 = <span className="truncate" {...t11}>{pricePlan.title}</span>;
      $[21] = pricePlan.title;
      $[22] = t11;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    if ($[24] !== pricePlan.title || $[25] !== t12) {
      t4 = <div className="truncate text-xl font-medium"><Tooltip mode="overflow" label={pricePlan.title}>{t12}</Tooltip></div>;
      $[24] = pricePlan.title;
      $[25] = t12;
      $[26] = t4;
    } else {
      t4 = $[26];
    }
    const t13 = isPriceInvisible && "invisible";
    let t14;
    if ($[27] !== t13) {
      t14 = twMerge("truncate", t13);
      $[27] = t13;
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    t5 = <div className={t14}><span className="text-xl lg:text-3xl">{costTitleShort}</span><span className="text-base font-normal">/{t(calculatedPeriod).toLowerCase()}</span></div>;
    t6 = active ? <PrimaryButton as={LinkWithoutPrefetch} href={calculatedLink} title={t("dashboard.settings.user_plan.current_plan_title")} className="bg-fill-primary !text-text-primary border border-transparent px-1" width="small" aria-disabled={true} testAttributePostfix={`button-plan-${pricePlan.title.toLowerCase()}-current`}><span className="truncate">{t("dashboard.settings.user_plan.current_plan_title")}</span></PrimaryButton> : isOneClickUpgradeAvailable ? <StripeWrapper><UpgradePlanConfirmationModal pricePlan={pricePlan} billingPeriod={billingPeriod} calculatedLink={calculatedLink} cost={costTitle + `/${t(calculatedPeriod).toLowerCase()}`} paymentMethod={paymentMethod} isPlanUpgradeAvailable={isPlanUpgradeAvailable} /></StripeWrapper> : <div className="flex flex-col gap-2"><PrimaryButton as={LinkWithoutPrefetch} href={calculatedLink} title={t("dashboard.settings.user_plan.upgrade_plan_title")} className="bg-brand-primary hover:bg-background-secondary hover:text-brand-primary hover:border-brand-primary disabled:bg-text-secondary border-[1px] px-1 hover:border-solid" aria-disabled={!calculatedLink || !isPlanUpgradeAvailable} testAttributePostfix={`link-plan-${pricePlan.title.toLowerCase()}-upgrade`}><span className="truncate">{t("dashboard.settings.user_plan.upgrade_plan_title")}</span></PrimaryButton></div>;
    $[0] = active;
    $[1] = billingPeriod;
    $[2] = isOneClickUpgradeAvailable;
    $[3] = isPlanUpgradeAvailable;
    $[4] = paymentMethod;
    $[5] = pricePlan;
    $[6] = showWithTax;
    $[7] = t;
    $[8] = user?.dashboardLocale;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[29] !== active || $[30] !== t || $[31] !== user?.accessRestricted) {
    t9 = active && user?.accessRestricted && <div className="text-danger text-center text-base font-normal">{t("dashboard.settings.user_plan.restricted")}</div>;
    $[29] = active;
    $[30] = t;
    $[31] = user?.accessRestricted;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t9) {
    t10 = <div className={t3}>{t4}{t5}{t6}{t9}</div>;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== t10 || $[40] !== t7 || $[41] !== t8) {
    t11 = <div key={t7} className={t8}>{t10}</div>;
    $[39] = t10;
    $[40] = t7;
    $[41] = t8;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  return t11;
};
export default HeaderBlock;